// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"502":"ucare-panel-chunk","868":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"502":"416887fe","609":"7b66b717","868":"c5d8b1b6"}[chunkId] + ".chunk.js";
};